import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import BarcodeScannerComponent from 'react-qr-barcode-scanner';
// import useSound from 'use-sound';
// import peepSound from '../assets/Barcode-scanner-beep-sound.mp3';
const BarcodeScanner = ({ Open, setOpen, onUpdate }) => {
    // const [play] = useSound(peepSound, { volume: 0.5 });
    const [stopStream, setStopStream] = useState(false);
    const handleClose = () => {
        // setOpen(false);
        setStopStream(true);
        setTimeout(() => setOpen(false), 0);
    };
    // useEffect(() => {
    //     play();
    // }, [Open]);
    return (
        <>
            <Dialog fullScreen open={Open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
                {/* <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Scan IMEI
                </DialogTitle> */}
                <DialogContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <BarcodeScannerComponent
                        // delay={100}
                        // torch={true}
                        //    facingMode='user'
                        // width={500}
                        // height={500}
                        onUpdate={(err, result) => {
                            if (result) {
                                // setData(field, result.text);
                                setOpen(false);
                                // play();
                            }
                            onUpdate(err, result);
                        }}
                        stopStream={stopStream}
                    />
                </DialogContent>
                <DialogActions>
                    {/* <button onClick={play}>Boop!</button> */}
                    <Button autoFocus onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default BarcodeScanner;
